/* eslint-disable import/prefer-default-export */
export class FrontMappings {
  static TARJETA = 'tarjetas';

  static AHORROS = 'ahorros';

  static ORO = 'tarjeta-oro';

  static PUNTOS_TRAVEL = 'puntos-travel';

  static SALDO = 'saldo';

  static MISDATOS = 'mis-datos';

  static COMPRAS = 'compras-y-tickets';

  static VALES = 'vales-ahorro';

  static REVISTA = 'revista-eroski-club';

  // url del bot
  static CAMBIO_PASS = 'change-pass';

  static CAMBIO_MAIL = 'change-mail';

  static BAJA_DIGITAL = 'baja-digital';

  static TARJETAS_BOT = 'tarjetas-bot';
}
